import { render, staticRenderFns } from "./Outdated.vue?vue&type=template&id=a0b4f0a8"
import script from "./Outdated.vue?vue&type=script&lang=js"
export * from "./Outdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports